import { NgModule } from '@angular/core';

import {
  PostImportCommandServiceModule,
  PostImportCommandComponentModule
} from '.';

@NgModule({
  imports: [
    PostImportCommandServiceModule,
    PostImportCommandComponentModule
  ],
  exports: [
    PostImportCommandServiceModule,
    PostImportCommandComponentModule
  ]
})
export class PostImportCommandModule { }
